(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimounou-3d-viewer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MV_SRC = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
  function loadMV() {
    window.ModelViewerElement = Object.assign(window.ModelViewerElement || {}, { meshoptDecoderLocation: 'https://cdn.jsdelivr.net/npm/meshoptimizer@0.21.0/meshopt_decoder.js' });
    if ((window.customElements && customElements.get('model-viewer')) || document.querySelector('script[data-m3v-lib]')) return;
    var s = document.createElement('script'); s.type = 'module'; s.src = MV_SRC; s.setAttribute('data-m3v-lib', '1'); document.head.appendChild(s);
  }
  function init(root) {
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var stage = root.querySelector('.m3v__stage'), slot = root.querySelector('[data-m3v-slot]');
    var lvBtns = [].slice.call(root.querySelectorAll('[data-level]'));
    var brBtn = root.querySelector('[data-breath]'), brLabel = root.querySelector('[data-breath-label]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mv = null, mat = null, loaded = false, target = 0, cur = 0, raf = 0, breathing = false;
    function apply(g) {
      stage.style.setProperty('--g', g.toFixed(3));
      if (!mv || !loaded) return;
      if (mat) { try { mat.setEmissiveFactor([g, g * (0.8 + 0.17 * g), g * (0.62 + 0.3 * g)]); } catch (e) {} }
      mv.exposure = 0.5 + g * 0.55;
    }
    function tween() {
      cancelAnimationFrame(raf);
      if (reduce) { cur = target; apply(cur); return; }
      (function step() {
        cur += (target - cur) * 0.14;
        if (Math.abs(target - cur) < 0.004) cur = target;
        apply(cur);
        if (cur !== target) raf = requestAnimationFrame(step);
      })();
    }
    function create() {
      if (mv) return; loadMV();
      mv = document.createElement('model-viewer');
      var a = {
        src: root.dataset.src, alt: 'Modèle 3D de la veilleuse ourson Mimounou, à faire tourner',
        'camera-controls': '', 'touch-action': 'pan-y', 'disable-zoom': '', 'disable-pan': '', 'interaction-prompt': 'none',
        'camera-orbit': '-28deg 62deg 105%', 'field-of-view': '30deg', 'min-camera-orbit': 'auto 20deg 1mm', 'max-camera-orbit': 'auto 100deg 50m',
        'min-field-of-view': '10deg', 'max-field-of-view': '60deg', 'shadow-intensity': '1', 'shadow-softness': '1', 'environment-image': 'neutral',
        exposure: '0.5', 'animation-name': 'breath', loading: 'eager', reveal: 'auto', 'interpolation-decay': '120'
      };
      if (!reduce) { a['auto-rotate'] = ''; a['auto-rotate-delay'] = '2500'; a['rotation-per-second'] = '14deg'; }
      Object.keys(a).forEach(function (k) { mv.setAttribute(k, a[k]); });
      mv.addEventListener('load', function () {
        loaded = true; root.classList.add('is-loaded');
        try { mat = mv.model.materials[0]; } catch (e) {}
        apply(cur);
        if (breathing) try { mv.play({ repetitions: Infinity }); } catch (e) {}
      });
      mv.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') root.classList.add('is-touched'); });
      slot.appendChild(mv);
    }
    lvBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        create();
        lvBtns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        target = parseFloat(b.dataset.level) || 0; tween();
      });
    });
    if (brBtn) brBtn.addEventListener('click', function () {
      create();
      breathing = !breathing;
      brBtn.setAttribute('aria-pressed', breathing ? 'true' : 'false');
      if (brLabel) brLabel.textContent = breathing ? brLabel.dataset.on : brLabel.dataset.off;
      if (loaded) { try { if (breathing) mv.play({ repetitions: Infinity }); else mv.pause(); } catch (e) {} }
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { create(); io.disconnect(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else create();
  }
  function boot() { document.querySelectorAll('[data-m3v]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimounou-fx"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Prix au format français : « €39,90 » -> « 39,90 € » (panier, recherche, etc.) */
  var RX = /€\s?(\d{1,3}(?:[.\s  ]\d{3})*(?:,\d{2})?)(\s?EUR)?/g;
  function fixText(node) {
    var t = node.nodeValue;
    if (!t || t.indexOf('€') < 0) return;
    RX.lastIndex = 0;
    if (!RX.test(t)) return;
    RX.lastIndex = 0;
    node.nodeValue = t.replace(RX, function (m, amount, code) { return amount + ' €'; });
  }
  function fixTree(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        return (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, list = [];
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('€') > -1) list.push(n);
    list.forEach(fixText);
  }
  function fixAttrs(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[aria-label*="€"],[title*="€"]').forEach(function (el) {
      ['aria-label', 'title'].forEach(function (a) {
        var v = el.getAttribute(a); if (v && v.indexOf('€') > -1) { RX.lastIndex = 0; el.setAttribute(a, v.replace(RX, function (m, x, c) { return x + ' €'; })); }
      });
    });
  }
  var pending = [], scheduled = false;
  function flush() { scheduled = false; var q = pending; pending = []; q.forEach(function (n) { fixTree(n); if (n.nodeType === 1) fixAttrs(n); }); }
  function queue(n) { pending.push(n); if (!scheduled) { scheduled = true; (window.requestAnimationFrame || setTimeout)(flush); } }
  function startMoney() {
    fixTree(document.body); fixAttrs(document.body);
    if ('MutationObserver' in window) new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') queue(m.target);
        else m.addedNodes.forEach(function (n) { queue(n); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* 2. Barre de progression de lecture */
  function startProgress() {
    var bar = document.querySelector('.mfx-progress'); if (!bar || reduce) return;
    var tick = false;
    function upd() {
      tick = false;
      var d = document.documentElement, max = (d.scrollHeight - window.innerHeight) || 1;
      var y = window.pageYOffset || d.scrollTop || 0;
      bar.style.setProperty('--mfx-p', Math.max(0, Math.min(1, y / max)).toFixed(4));
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* 3. Apparition des blocs au défilement (sections Mimounou sans animation Dawn) */
  var ROOTS = '.mu,.mmo,.mbn,.mwy,.mrv,.mct,.msp,.mfc,.mpr,.mfq,.m3v,.mst';
  var GROUPS = '.mu-grid,.mbn-grid,.mrv-grid,.mwy-grid,.msp-steps,.mfq-list,.mpr-grid,.mfc-grid';
  function startReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight, targets = [];
    document.querySelectorAll(ROOTS).forEach(function (sec) {
      if (sec.closest('.mx3') || sec.closest('.product__info-wrapper')) return;
      var pw = sec.querySelector('.page-width') || sec;
      var stag = pw.matches(GROUPS);
      [].slice.call(pw.children).forEach(function (el, idx) {
        if (stag) targets.push([el, Math.min(idx, 6) * 0.08]);
        else if (el.matches(GROUPS)) {
          [].slice.call(el.children).forEach(function (c, i) { targets.push([c, Math.min(i, 6) * 0.08]); });
        } else if (el.querySelector && el.querySelector(GROUPS)) {
          targets.push([el, 0]);
          [].slice.call(el.querySelector(GROUPS).children).forEach(function (c, i) { targets.push([c, 0.1 + Math.min(i, 6) * 0.08]); });
        } else targets.push([el, 0]);
      });
    });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mfx-in');
        io.unobserve(e.target);
        setTimeout(function () { e.target.classList.remove('mfx-pre', 'mfx-in'); e.target.style.removeProperty('--mfx-d'); }, 1600);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) {
      var el = t[0];
      if (el.classList.contains('scroll-trigger') || el.closest('.scroll-trigger')) return;
      if (el.getBoundingClientRect().top < vh * 0.92) return; /* déjà visible : on ne cache rien */
      el.classList.add('mfx-pre');
      if (t[1]) el.style.setProperty('--mfx-d', t[1] + 's');
      io.observe(el);
    });
  }

  /* 4. Cartes qui s'inclinent légèrement au survol (souris uniquement) */
  function startTilt() {
    if (reduce || !(window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches)) return;
    document.querySelectorAll('.mbn-card,.mrv-card').forEach(function (c) {
      c.classList.add('mfx-tilt');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        c.style.setProperty('--ry', (x * 6).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
        c.classList.add('is-tilting');
      });
      c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); c.classList.remove('is-tilting'); });
    });
  }

  function boot() { startMoney(); startProgress(); startReveal(); startTilt(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimounou-x3d"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function initSky(canvas, state) {
    var ctx = canvas.getContext('2d'); if (!ctx) return function () {};
    var stars = [], flies = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    function resize() {
      var r = canvas.getBoundingClientRect(); w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = []; flies = [];
      var small = w < 990, ns = Math.round(w * h / (small ? 16000 : 10000)), nf = small ? 10 : 20;
      for (var i = 0; i < ns; i++) stars.push({ x: Math.random() * w, y: Math.random() * h * .75, r: Math.random() * 1.1 + .3, t: Math.random() * 6.28, s: Math.random() * .02 + .004, z: Math.random() });
      for (var j = 0; j < nf; j++) flies.push({ x: Math.random() * w, y: h * (.4 + Math.random() * .6), r: Math.random() * 1.6 + 1, vx: (Math.random() - .5) * .22, vy: -(Math.random() * .22 + .05), t: Math.random() * 6.28 });
    }
    resize(); window.addEventListener('resize', resize, { passive: true });
    return function draw() {
      ctx.clearRect(0, 0, w, h);
      var g = state.glow, p = state.p;
      ctx.fillStyle = '#FFF4E0';
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i]; s.t += s.s;
        ctx.globalAlpha = (.3 + .6 * Math.abs(Math.sin(s.t))) * (1 - g * .55);
        ctx.beginPath(); ctx.arc(s.x, s.y - p * 60 * (s.z + .3), s.r, 0, 6.283); ctx.fill();
      }
      for (var j = 0; j < flies.length; j++) {
        var f = flies[j]; f.t += .03; f.x += f.vx + Math.sin(f.t) * .15; f.y += f.vy;
        if (f.y < h * .2) { f.y = h + 10; f.x = Math.random() * w; }
        var fa = (.2 + .45 * Math.abs(Math.sin(f.t))) * (.35 + g * .65);
        var grd = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 5);
        grd.addColorStop(0, 'rgba(242,182,109,' + fa + ')'); grd.addColorStop(1, 'rgba(242,182,109,0)');
        ctx.globalAlpha = 1; ctx.fillStyle = grd; ctx.beginPath(); ctx.arc(f.x, f.y, f.r * 5, 0, 6.283); ctx.fill();
        ctx.fillStyle = '#FFF4E0';
      }
      ctx.globalAlpha = 1;
    };
  }

  function init(root) {
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var mv = root.querySelector('model-viewer');
    var track = root.querySelector('.mx3__track');
    var stage = root.querySelector('.mx3__stage');
    var chs = [].slice.call(root.querySelectorAll('.mx3__ch'));
    var dots = [].slice.call(root.querySelectorAll('.mx3__dots li'));
    var lvEls = [].slice.call(root.querySelectorAll('.mx3__levels span'));
    var clock = root.querySelector('.mx3__clock');
    var n = chs.length; if (!n || !mv) return;
    var kf = chs.map(function (c) { return { th: +c.dataset.theta || 0, ph: +c.dataset.phi || 64, zm: +c.dataset.zoom || 105, g: (+c.dataset.glow || 0) / 100, ef: c.dataset.effect || 'none' }; });
    var pts = [];
    kf.forEach(function (k, i) {
      if (k.ef === 'levels') pts.push([i - .45, .3], [i - .14, .3], [i - .1, .6], [i + .1, .6], [i + .14, 1], [i + .45, 1]);
      else if (k.ef === 'timer') pts.push([i - .35, k.g], [i + .38, 0]);
      else pts.push([i, k.g]);
    });
    pts.sort(function (a, b) { return a[0] - b[0]; });
    function glowAt(x) {
      if (x <= pts[0][0]) return pts[0][1];
      for (var i = 1; i < pts.length; i++) if (x <= pts[i][0]) { var a = pts[i - 1], b = pts[i]; return lerp(a[1], b[1], (x - a[0]) / ((b[0] - a[0]) || 1)); }
      return pts[pts.length - 1][1];
    }
    var state = { p: 0, x: 0, glow: kf[0].g, breath: 0 };
    var mat = null, lastG = -1, loaded = false, breathing = false;
    function setGlow(g) {
      if (Math.abs(g - lastG) < .004) return; lastG = g;
      if (mat) { try { mat.setEmissiveFactor([g, g * (.8 + .17 * g), g * (.62 + .3 * g)]); } catch (e) {} }
      mv.exposure = .34 + g * .7;
    }
    function setBreath(on) {
      if (!loaded || on === breathing) return; breathing = on;
      try { if (on) mv.play({ repetitions: Infinity }); else mv.pause(); } catch (e) {}
    }
    mv.addEventListener('load', function () {
      loaded = true;
      try { mat = mv.model.materials[0]; } catch (e) {}
      lastG = -1; setGlow(state.glow);
      root.classList.add('mx3--loaded');
    });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { state.glow = .5; mv.addEventListener('load', function () { setGlow(.5); }); chs.forEach(function (c) { c.style.setProperty('--o', 1); }); return; }
    root.classList.add('mx3--on');
    var sky = initSky(root.querySelector('.mx3__sky'), state);

    function progress() {
      var r = track.getBoundingClientRect(); var total = r.height - window.innerHeight;
      return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
    }
    function update() {
      var p = progress(), x = p * (n - 1), i = Math.min(n - 2, Math.floor(x)), f = x - Math.max(0, i);
      if (n === 1) { i = 0; f = 0; }
      var a = kf[Math.max(0, i)], b = kf[Math.min(n - 1, i + 1)];
      var e = ease(clamp((f - .2) / .6, 0, 1));
      var th = lerp(a.th, b.th, e) + (f - .5) * 6, ph = lerp(a.ph, b.ph, e), zm = lerp(a.zm, b.zm, e);
      mv.cameraOrbit = th.toFixed(2) + 'deg ' + ph.toFixed(2) + 'deg ' + zm.toFixed(1) + '%';
      var g = glowAt(x); state.p = p; state.x = x; state.glow = g; setGlow(g);
      root.style.setProperty('--p', p.toFixed(4)); root.style.setProperty('--glow', g.toFixed(3));
      var sr = stage.getBoundingClientRect(); root.style.setProperty('--cut', Math.max(0, Math.round(sr.bottom - window.innerHeight)) + 'px');
      var k = clamp(Math.round(x), 0, n - 1), lv = 0, tm = 0, br = 0;
      chs.forEach(function (c, j) {
        var d = x - j, o = clamp(1 - Math.abs(d) * 2.3, 0, 1);
        c.style.setProperty('--o', o.toFixed(3)); c.style.setProperty('--dy', (-d * 60).toFixed(1) + 'px');
        c.classList.toggle('is-active', o > .55);
        if (kf[j].ef === 'levels') lv = Math.max(lv, o);
        if (kf[j].ef === 'timer') {
          tm = Math.max(tm, o);
          var lt = clamp((x - (j - .35)) / .73, 0, 1);
          root.style.setProperty('--to', (lt * 100).toFixed(1));
          if (clock) { var m = Math.round(30 * (1 - lt)); clock.textContent = (m < 10 ? '0' : '') + m + ':00'; }
        }
        if (kf[j].ef === 'breath') br = Math.max(br, o);
      });
      root.style.setProperty('--lv', lv.toFixed(3)); root.style.setProperty('--tm', tm.toFixed(3));
      state.breath = br; setBreath(br > .45 && visible);
      lvEls.forEach(function (s) { s.classList.toggle('is-on', g >= (+s.dataset.l) - .02 && lv > .2); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }
    var visible = true, ticking = false;
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mv.addEventListener('load', onScroll);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) loop(); else setBreath(false); }, { rootMargin: '100px' }).observe(root);
    var running = false;
    function loop() {
      if (running) return; running = true;
      (function frame() {
        if (!visible || document.hidden) { running = false; return; }
        sky();
        requestAnimationFrame(frame);
      })();
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) loop(); });
    update(); loop();
  }
  function boot() { document.querySelectorAll('[data-mx3]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
